import { useDateFormatter, useTimeFormatter } from '@myn/mui';

export type Props = { editedAt: string };

const DateTimeCell = ({ editedAt }: Props) => {
  const dateFormatter = useDateFormatter();
  const timeFormatter = useTimeFormatter();

  return (
    <div className="flex">
      {`${dateFormatter.format(editedAt)} - ${timeFormatter.format(editedAt)}`}
    </div>
  );
};

export default DateTimeCell;
